import { Routes } from '@angular/router';
import { AuthGuard, LoginGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.module').then(m => m.AuthModule),
    canActivate: [LoginGuard]
  },

  {
    path: 'login/callback',
    loadComponent: () =>
      import('./features/auth/login/login-callback/login-callback.component')
        .then(m => m.LoginCallbackComponent),
    canActivate: [LoginGuard]
  },

  {
    path: 'dashboard',
    loadComponent: () =>
      import('./features/dashboard/dashboard.component')
        .then(m => m.DashboardComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'productUpload',
    loadComponent: () =>
      import('./features/product-upload/product-upload.component')
        .then(m => m.ProductUploadComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'locationUpload',
    loadComponent: () =>
      import('./features/location-upload/location-upload.component')
        .then(m => m.LocationUploadComponent),
    canActivate: [AuthGuard]
  },

  { path: '', redirectTo: '/dashboard', pathMatch: 'full' as const },
  { path: '**', redirectTo: '/auth/login' }
];